import styled from "styled-components";



export const BoxModal = styled.div<any>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 70vw;
    min-width: ${(props) => props.size};
    background-color: #FFFFFF;
    border-radius: 7px;

    border: none;
    max-height: 90vh;
`;

export const Title = styled.div<any>`
    width: 100%;
    background-image: url(${(props) => props.bgImagen});
    background-size: cover;
    background-repeat: no-repeat;
    font-weight: 400;
    font-size: x-large;
    text-align: start;
    color: #FFFFFF;
    padding-left: 10px;
    padding-top: 20px;
    padding-bottom: 20px;
    
`;

export const Container = styled.div`
    padding: 0px;
    background-color: #f8f8f8;
    border-radius: 5px;

    position: relative;
    max-height: 80vh;
    overflow-y: auto;

    #boxAcciones {
        position: absolute;
        right: 0px;
        top: -29px;

        .MuiButtonBase-root {
            font-size: 35px;
        }
    }
    
`;

export const BtnClose = styled.div`
    position: absolute;
    top: 0;
    right: 0;

    svg {
        color: red;
    }
`;